import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ManualKpiSuggestion} from '../types'

export const KpiSuggestionsQueryKey = 'kpi-suggestions'

type UseKpiSuggestionsParams = {
  plantId: string
  options?: Omit<UseQueryOptions<ManualKpiSuggestion[], AxiosError>, 'queryKey'>
}

export const useKpiSuggestions = ({plantId, options}: UseKpiSuggestionsParams) => {
  const path = `/shifthandover/${plantId}/kpi-suggestions`

  return useQuery<ManualKpiSuggestion[], AxiosError>({
    queryKey: [KpiSuggestionsQueryKey, plantId],
    queryFn: async () => {
      const response = await ApiClient.axiosInstance.get<ManualKpiSuggestion[]>(path)
      return response.data
    },
    ...options
  })
}
